import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  {
    path: '/workflowactions',
    name: 'workflowactions',
    component: () =>
      import(/* webpackChunkName: "workflow-action-page" */ './pages/WorkflowActionPage.vue'),
  },
  Module.WORKFLOWACTION
);
